import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { number, string } from 'prop-types';
import { DynamicComponent } from '@thd-nucleus/app-render';
import { SponsoredCarousel } from '@thd-olt-component-react/sponsored-content';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { AUTHORIZATION_STATUS } from '../../utils';

export function SponsoredProducts({
  userAuthStatus,
  customRenderId,
  slidesPer,
  id,
}) {
  const { channel } = useContext(ExperienceContext);
  const thdCustomer = useThdCustomer();
  const CAROUSEL_HYDRATION_STANDARD_SCROLL_BUFFER = 750;
  const userId = thdCustomer.svocID || thdCustomer.userID || thdCustomer.guestUserID;

  return (
    <ErrorBoundary name="sponsored-products-php">
      <DynamicComponent pageType="homepage">
        <SponsoredCarousel
          browserId={thdCustomer?.mcvisID || ''}
          userId={userId || ''}
          slidesPer={slidesPer}
          pageContext={{
            schema:
              userAuthStatus === AUTHORIZATION_STATUS.GUEST
                ? 'hp_sponsored'
                : 'hp_sponsored_auth',
            page: 'home',
          }}
          noATCFulfillment
          hideCarouselArrows={channel === 'mobile'}
          utilizeRvData
          dynamic={{
            pageType: 'homepage'
          }}
          hydrator={{
            className: 'grid',
            scrollBuffer: CAROUSEL_HYDRATION_STANDARD_SCROLL_BUFFER
          }}
        />
      </DynamicComponent>
    </ErrorBoundary>
  );
}

SponsoredProducts.propTypes = {
  userAuthStatus: string,
  customRenderId: string,
  slidesPer: number,
  id: string,
};

SponsoredProducts.defaultProps = {
  userAuthStatus: undefined,
  customRenderId: undefined,
  slidesPer: undefined,
  id: undefined,
};
